module.exports = __webpack_public_path__ + "img/zw.a21f533.svg";